/**
 * Returns a list of encryption targets for a conversation,
 * based on current Kyber sessions and handshake status.
 *
 * @param {Array} participants
 * @returns {Array<{ identityViewPublicKey, contactNextViewPublicKey, kyberSecret }>}
 */
export function getMessageTargets(participants = []) {
  return participants
    .map((p) => {
      const sessionKeys = p.keys?.sessionKyberKeys || [];
      const lastValidSession = [...sessionKeys].reverse().find(k => k.kyberSecret);

      if (
        p.identityViewPublicKey &&
        p.keys?.contactNextViewPublicKey &&
        lastValidSession?.kyberSecret
      ) {
        return {
          identityViewPublicKey: p.identityViewPublicKey,
          contactNextViewPublicKey: p.keys.contactNextViewPublicKey,
          kyberSecret: lastValidSession.kyberSecret,
        };
      }

      return null;
    })
    .filter(Boolean);
}